export default __webpack_public_path__ + "static/media/numpy.9eca1f7a.png";